import React, {
  ChangeEvent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { Form } from '@unform/web';
import { FormHandles } from '@unform/core';
import { Grid } from '@material-ui/core';
import { BsTrash } from 'react-icons/bs';

import { useProdutoPizza } from '../../../../../../../hooks/produtoPizza';
import { useToast } from '../../../../../../../hooks/toast';

import schedulesOptions from '../../../../../utils/schedulesOptions';

import api from '../../../../../../../services/api';

import {
  DisponibilidadeWrapper,
  DrawerTabTitle,
  RadioDisponibilidadeWrapper,
  TabWrapper,
  AddButton,
  ButtonAction,
  SelectTurno,
} from '../../../drawer_styles';
import material_styles from '../../../drawer_styles/material_styles';
import { SubmitButtonWrapper } from '../../../../styles';
import { useRegisterAdded } from '../../../../../../../hooks/registerAdded';

interface TurnoType {
  inicio: number;
  fim: number;
}

interface QtdTurnos {
  index: number;
}

interface SelectedTurnos {
  [inputName: string]: {
    id: number;
    value: number;
    label: string;
  };
}

const Disponibilidade: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const classes = material_styles();

  const {
    produtoId,
    cloning,
    resetDrawer,
    createNewProdutoPizza,
    updateProdutoPizza,
    changeCurrentTabIndex,
  } = useProdutoPizza();
  const { addToast } = useToast();
  const { handleSetHasProductUpdated } = useRegisterAdded();

  const [sempreDisponivel, setSempreDisponivel] = useState(true);
  const [qtdTurnos, setQtdTurnos] = useState<QtdTurnos[]>([]);
  const [selectedTurnos, setSelectedTurnos] = useState<SelectedTurnos>();
  const [days, setDays] = useState({
    domingo: true,
    segunda: true,
    terca: true,
    quarta: true,
    quinta: true,
    sexta: true,
    sabado: true,
  });
  const [btnDisable, setBtnDisable] = useState(false);

  useEffect(() => {
    async function loadDisponibilidade(): Promise<void> {
      setBtnDisable(true);

      try {
        const response = await api.get(`/produto/disponibilidade/${produtoId}`);

        const { dias, turnos } = response.data.role;

        setDays(dias);

        const initialDataTurnos = {};

        const isSempreDisponivel = Object.values(dias).every((value) => value);

        if (turnos.length > 0 || !isSempreDisponivel) {
          turnos.forEach((turno: any, index: number) => {
            Object.assign(initialDataTurnos, {
              [`${index}_turno_inicio`]: {
                id: index,
                value: index,
                label: turno.inicio,
              },
              [`${index}_turno_fim`]: {
                id: index,
                value: index,
                label: turno.fim,
              },
            });
          });

          setQtdTurnos(
            Array(turnos.length)
              .fill('')
              .map((_item, index) => ({ index })),
          );
          setSelectedTurnos(initialDataTurnos);
          setSempreDisponivel(false);
        }

        setBtnDisable(false);
      } catch (err) {
        addToast({
          title: 'Erro ao obter a disponibilidade',
          type: 'error',
          description: err.response?.data.message,
        });

        setBtnDisable(false);
      }
    }

    if (produtoId) {
      loadDisponibilidade();
    }
  }, [addToast, produtoId]);

  const handleSetDisponibilidade = useCallback((invisible: boolean) => {
    if (invisible) {
      setDays({
        domingo: true,
        segunda: true,
        terca: true,
        quarta: true,
        quinta: true,
        sexta: true,
        sabado: true,
      });
    }

    setSempreDisponivel(invisible);
  }, []);

  const handleChangeDay = useCallback((name: string, checked: boolean) => {
    setDays((oldState) => ({
      ...oldState,
      [name]: checked,
    }));
  }, []);

  const handleChangeTurno = useCallback((name: string, value: any) => {
    setSelectedTurnos((oldState) => ({
      ...oldState,
      [name]: value,
    }));
  }, []);

  const handleAddTurno = useCallback(() => {
    setQtdTurnos((oldState) => [
      ...oldState,
      {
        index: oldState.length,
      },
    ]);
  }, []);

  const handleRemoveTurno = useCallback(
    (index: number) => {
      const turnosStoreds = qtdTurnos.filter((turno) => turno.index !== index);

      setQtdTurnos(
        turnosStoreds.map((turno, turnoIndex) => ({
          index: turnoIndex,
        })),
      );
    },
    [qtdTurnos],
  );

  const handleSubmit = useCallback(
    async (data: any) => {
      setBtnDisable(true);
      let allIsFine = true;
      const turnoType: TurnoType[] = [];

      if (!sempreDisponivel && selectedTurnos) {
        qtdTurnos.forEach((turno) => {
          const inicio = Number(
            selectedTurnos[`${turno.index}_turno_inicio`].label,
          );
          const fim = Number(selectedTurnos[`${turno.index}_turno_fim`].label);

          if (inicio > fim) {
            addToast({
              type: 'error',
              title: 'Turno inválido.',
              description: 'O início do turno deve ser maior que o fim',
            });
            setBtnDisable(false);
            allIsFine = false;

            return;
          }

          const turnoObjectType: TurnoType = {
            inicio,
            fim,
          };

          turnoType.push(turnoObjectType);
          allIsFine = true;
        });
      }

      if (allIsFine) {
        try {
          addToast({
            type: 'info',
            title: 'Aguarde',
            description: `Seu produto está sendo ${
              produtoId && !cloning ? 'editado' : 'criado'
            }`,
          });

          if (produtoId && !cloning) {
            await updateProdutoPizza({
              dias: days,
              turnos: sempreDisponivel ? [] : turnoType,
            });
          } else {
            await createNewProdutoPizza({
              dias: days,
              turnos: sempreDisponivel ? [] : turnoType,
            });
          }

          addToast({
            type: 'success',
            title: `Produto ${
              produtoId && !cloning ? 'editado' : 'criado'
            } com sucesso!`,
          });

          handleSetHasProductUpdated(true);
          resetDrawer();
        } catch (err) {
          addToast({
            title: 'Ocorreu um erro!',
            type: 'error',
            description:
              err.response?.data.message ||
              'Ocorreu um erro ao criar o produto. Tente novamente.',
          });

          if (err.response?.data.message === 'Código PDV já registrado') {
            changeCurrentTabIndex(1);
          }
          setBtnDisable(false);
        }
      }
    },
    [
      days,
      cloning,
      qtdTurnos,
      produtoId,
      selectedTurnos,
      sempreDisponivel,
      resetDrawer,
      addToast,
      updateProdutoPizza,
      createNewProdutoPizza,
      changeCurrentTabIndex,
      handleSetHasProductUpdated,
    ],
  );

  return (
    <TabWrapper>
      <DrawerTabTitle>
        <h1>Disponibilidade</h1>
        <span>
          Defina os momentos em que os clientes poderão comprar este item.
        </span>
      </DrawerTabTitle>

      <Form ref={formRef} onSubmit={handleSubmit}>
        <Grid container spacing={3}>
          <Grid item xs={12} className={classes.noPaddingBot}>
            <RadioDisponibilidadeWrapper>
              <form>
                <div>
                  <label htmlFor="no_have">
                    <input
                      type="radio"
                      id="no_have"
                      name="has_complemento"
                      value="no"
                      checked={sempreDisponivel}
                      onClick={() => handleSetDisponibilidade(true)}
                    />
                    Sempre Disponível
                  </label>
                  <span>
                    O item ficará disponível sempre que o restaurante estiver
                    aberto
                  </span>
                </div>

                <div>
                  <label htmlFor="have">
                    <input
                      type="radio"
                      id="have"
                      name="has_complemento"
                      value="yes"
                      checked={!sempreDisponivel}
                      onClick={() => handleSetDisponibilidade(false)}
                    />
                    Disponível em dias e horários específicos
                  </label>
                  <span>Selecione os dias que o item estará disponível</span>
                </div>
              </form>
            </RadioDisponibilidadeWrapper>
          </Grid>

          <Grid item xs={12} className={classes.noPaddingTop}>
            <DisponibilidadeWrapper isInvisible={sempreDisponivel}>
              <div className="dias">
                <span>Dias da Semana</span>

                <input
                  type="checkbox"
                  id="domingo"
                  name="domingo"
                  value="domingo"
                  checked={days.domingo}
                />
                <label
                  htmlFor="domingo"
                  onClick={() => handleChangeDay('domingo', !days.domingo)}
                >
                  D
                </label>

                <input
                  type="checkbox"
                  id="segunda"
                  name="segunda"
                  value="segunda"
                  checked={days.segunda}
                />
                <label
                  htmlFor="segunda"
                  onClick={() => handleChangeDay('segunda', !days.segunda)}
                >
                  S
                </label>

                <input
                  type="checkbox"
                  id="terca"
                  name="terca"
                  value="terca"
                  checked={days.terca}
                />
                <label
                  htmlFor="terca"
                  onClick={() => handleChangeDay('terca', !days.terca)}
                >
                  T
                </label>

                <input
                  type="checkbox"
                  id="quarta"
                  name="quarta"
                  value="quarta"
                  checked={days.quarta}
                />
                <label
                  htmlFor="quarta"
                  onClick={() => handleChangeDay('quarta', !days.quarta)}
                >
                  Q
                </label>

                <input
                  type="checkbox"
                  id="quinta"
                  name="quinta"
                  value="quinta"
                  checked={days.quinta}
                />
                <label
                  htmlFor="quinta"
                  onClick={() => handleChangeDay('quinta', !days.quinta)}
                >
                  Q
                </label>

                <input
                  type="checkbox"
                  id="sexta"
                  name="sexta"
                  value="sexta"
                  checked={days.sexta}
                />
                <label
                  htmlFor="sexta"
                  onClick={() => handleChangeDay('sexta', !days.sexta)}
                >
                  S
                </label>

                <input
                  type="checkbox"
                  id="sabado"
                  name="sabado"
                  value="sabado"
                  checked={days.sabado}
                />
                <label
                  htmlFor="sabado"
                  onClick={() => handleChangeDay('sabado', !days.sabado)}
                >
                  S
                </label>
              </div>

              <div className="turno_wrapper">
                <div className="title_wrapper">
                  <span>Horários</span>
                  <AddButton type="button" onClick={handleAddTurno}>
                    + Adicionar Turno
                  </AddButton>
                </div>

                {qtdTurnos.map((item) => (
                  <div key={item.index} className="turnos_wrapper">
                    <div className="turno">
                      <span>{`${item.index + 1}º Turno`}</span>
                      <SelectTurno
                        name={`${item.index}_turno_inicio`}
                        placeholder="Selecione"
                        value={selectedTurnos?.[`${item.index}_turno_inicio`]}
                        onChange={(value: any) =>
                          handleChangeTurno(`${item.index}_turno_inicio`, value)
                        }
                        options={schedulesOptions}
                      />
                      <SelectTurno
                        name={`${item.index}_turno_fim`}
                        placeholder="Selecione"
                        value={selectedTurnos?.[`${item.index}_turno_fim`]}
                        onChange={(value: any) =>
                          handleChangeTurno(`${item.index}_turno_fim`, value)
                        }
                        options={schedulesOptions}
                      />

                      <button
                        type="button"
                        onClick={() => handleRemoveTurno(item.index)}
                      >
                        <BsTrash size={16} />
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            </DisponibilidadeWrapper>
          </Grid>

          <Grid item xs={12} className={classes.noPaddingBot}>
            <SubmitButtonWrapper>
              <ButtonAction
                type="button"
                className="cancel"
                onClick={resetDrawer}
              >
                Cancelar
              </ButtonAction>

              <ButtonAction
                type="submit"
                className="submit"
                disabled={btnDisable}
              >
                Salvar
              </ButtonAction>
            </SubmitButtonWrapper>
          </Grid>
        </Grid>
      </Form>
    </TabWrapper>
  );
};

export default Disponibilidade;
